import React from 'react';
import { XCircle, CheckCircle, ShieldCheck, TrendingDown, Zap } from 'lucide-react';
export function TwoPathsSection() {
  return <section className="py-4 md:py-14 px-6 bg-background" data-id="element-317">
      <div className="max-w-5xl mx-auto" data-id="element-318">
        <div className="text-center mb-8 md:mb-16" data-id="element-319">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-320">
            En este momento estás frente a dos caminos:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-0 mb-8 md:mb-16 relative" data-id="element-321">
          {/* Divider */}
          <div className="hidden md:flex absolute left-1/2 top-0 bottom-0 -translate-x-1/2 flex-col items-center justify-center z-10" data-id="element-322">
            <div className="w-0.5 h-full bg-navy/10" data-id="element-323"></div>
            <div className="absolute top-1/2 -translate-y-1/2 bg-background px-3 py-2 text-navy/40 font-bold text-sm tracking-wider uppercase" data-id="element-324">
              VS
            </div>
          </div>

          {/* Path A — Frustration */}
          <div className="bg-white p-8 md:p-10 rounded-l-2xl md:rounded-r-none rounded-2xl md:rounded-bl-2xl border border-red-200 shadow-sm relative opacity-85" data-id="element-325">
            <div className="absolute top-4 right-4 bg-red-50 text-red-400 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-326">
              Estancamiento
            </div>
            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-red-100" data-id="element-327">
              <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center" data-id="element-328">
                <TrendingDown className="w-6 h-6 text-red-300" data-id="element-329" />
              </div>
              <div data-id="element-330">
                <h3 className="text-2xl font-bold text-navy/80" data-id="element-331">Camino A</h3>
                <span className="text-sm text-red-300 font-medium" data-id="element-332">
                  El Camino de la Frustración
                </span>
              </div>
            </div>
            <ul className="space-y-4 text-navy/60" data-id="element-333">
              <li className="flex items-start gap-3" data-id="element-334">
                <XCircle className="w-5 h-5 text-red-300 flex-shrink-0 mt-0.5" data-id="element-335" />
                <span data-id="element-336">
                  Cerrás esta página y{' '}
                  <strong className="text-navy/70" data-id="element-337">
                    seguís haciendo lo "correcto"
                  </strong>
                  .
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-338">
                <XCircle className="w-5 h-5 text-red-300 flex-shrink-0 mt-0.5" data-id="element-339" />
                <span data-id="element-340">
                  Seguís{' '}
                  <strong className="text-navy/70" data-id="element-341">
                    pidiéndole energía prestada al café para sobrevivir
                  </strong>
                  .
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-342">
                <XCircle className="w-5 h-5 text-red-300 flex-shrink-0 mt-0.5" data-id="element-343" />
                <span data-id="element-344">
                  Aceptás que el{' '}
                  <strong className="text-navy/70" data-id="element-345">cansancio</strong> y la{' '}
                  <strong className="text-navy/70" data-id="element-346">niebla mental</strong> son
                  "normales a tu edad".
                </span>
              </li>
            </ul>
          </div>

          {/* Separator on mobile */}
          <div className="flex md:hidden items-center justify-center py-4" data-id="element-347">
            <div className="h-0.5 w-16 bg-navy/10" data-id="element-348"></div>
            <span className="px-3 text-navy/40 font-bold text-sm" data-id="element-349">VS</span>
            <div className="h-0.5 w-16 bg-navy/10" data-id="element-350"></div>
          </div>

          {/* Path B — Metabolic Reset */}
          <div className="bg-white p-8 md:p-10 rounded-r-2xl md:rounded-l-none rounded-2xl md:rounded-tr-2xl border-2 border-accent shadow-xl relative" data-id="element-351">
            <div className="absolute top-4 right-4 bg-accent text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-352">
              Recomendado
            </div>
            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-accent/20" data-id="element-353">
              <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center" data-id="element-354">
                <Zap className="w-6 h-6 text-accent" data-id="element-355" />
              </div>
              <div data-id="element-356">
                <h3 className="text-2xl font-bold text-navy" data-id="element-357">Camino B</h3>
                <span className="text-sm text-accent font-medium" data-id="element-358">
                  El Reinicio Metabólico
                </span>
              </div>
            </div>
            <ul className="space-y-4 text-navy/90 font-medium" data-id="element-359">
              <li className="flex items-start gap-3" data-id="element-360">
                <CheckCircle className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-361" />
                <span data-id="element-362">
                  Probás algo diferente durante solo{' '}
                  <strong className="text-navy" data-id="element-363">72 horas</strong>.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-364">
                <CheckCircle className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-365" />
                <span data-id="element-366">
                  <strong className="text-navy" data-id="element-367">Limpiás tu sistema</strong> y{' '}
                  <span className="text-accent font-semibold" data-id="element-368">
                    recuperás tu enfoque
                  </span>
                  .
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-369">
                <CheckCircle className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-370" />
                <span data-id="element-371">
                  Ves cómo tu cuerpo{' '}
                  <span className="text-accent font-semibold" data-id="element-372">
                    responde cuando dejás de atacarlo
                  </span>
                  .
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Guarantee Box */}
        <div className="bg-amber/10 border border-amber/30 p-8 md:p-10 rounded-2xl max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-373">
          <ShieldCheck className="w-20 h-20 text-amber flex-shrink-0" data-id="element-374" />
          <div data-id="element-375">
            <h4 className="text-xl font-bold text-navy mb-3" data-id="element-376">
              Garantía de Satisfacción de 7 Días
            </h4>
            <p className="text-navy/80 leading-relaxed" data-id="element-377">
              Si elegís el Camino B, yo asumo todo el riesgo. Tenés una semana
              entera para evaluar el manual. Si después de aplicar el protocolo
              de <strong className="text-navy" data-id="element-378">72 horas</strong> no notás un
              cambio real en tu{' '}
              <strong className="text-navy" data-id="element-379">claridad mental</strong> y tus
              niveles de energía, me mandás un mensaje y te devuelvo el 100% de
              tu inversión. Sin preguntas incómodas y sin vueltas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}